class CartRecommendationsV2 extends HTMLElement {
  async connectedCallback() {
    if (this.children.length === 0) {
      const { productId, url } = this.dataset;
      if (!productId || !url) return;
      try {
        const response = await fetch(`${url}&product_id=${productId}`);
        const next = new DOMParser()
          .parseFromString(await response.text(), 'text/html')
          .querySelector('cart-recommendations-v2');
        if (!next?.children.length) return;
        this.replaceChildren(...next.childNodes);
      } catch (error) {
        console.warn('[cart-recommendations-v2] load failed', error);
        return;
      }
    }
    this.init();
  }

  init() {
    this.scroller = this.querySelector('[data-cr-scroller]');
    if (!this.scroller) return;

    this.prevButton = this.querySelector('[data-cr-prev]');
    this.nextButton = this.querySelector('[data-cr-next]');

    this.update = this.update.bind(this);
    this.prevButton?.addEventListener('click', () => this.step(-1));
    this.nextButton?.addEventListener('click', () => this.step(1));
    this.scroller.addEventListener('scroll', this.update, { passive: true });

    this.querySelectorAll('[data-cr-card]').forEach((card) => this.initCard(card));
    this.update();
  }

  initCard(card) {
    const select = card.querySelector('[data-cr-variant]');
    const addButton = card.querySelector('[data-cr-add]');
    const image = card.querySelector('.cart-recommendations-v2__image');
    const prices = card.querySelector('[data-cr-prices]');
    const caption = card.querySelector('.star-rating__caption');

    if (caption) {
      const match = caption.textContent.match(/\d+/);
      if (match) caption.textContent = `(${match[0]} reviews)`;
    }

    select?.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      if (!option) return;
      addButton.dataset.variantId = option.value;
      const { price, compare, image: variantImage } = option.dataset;
      if (prices && price) {
        prices.innerHTML =
          compare && compare !== price
            ? `<span class="cart-recommendations-v2__price-compare">${compare}</span><span class="cart-recommendations-v2__price">${price}</span>`
            : `<span class="cart-recommendations-v2__price">${price}</span>`;
      }
      if (image && variantImage) image.src = variantImage;
    });

    addButton?.addEventListener('click', () => this.add(addButton));
  }

  async add(button) {
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: 'cart-drawer-v2,header-v2,header',
          sections_url: window.location.pathname,
        }),
      });
      const data = await response.json();
      if (!response.ok || data.status === 422) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: 'cart-recommendations',
          errors: data.errors,
          message: data.description || data.message,
        });
        throw new Error(`add failed: ${response.status}`);
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-recommendations',
        cartData: data,
        variantId,
      });
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  step(direction) {
    const item = this.scroller.firstElementChild;
    const distance = item ? item.offsetWidth : this.scroller.clientWidth;
    this.scroller.scrollBy({ left: distance * direction, behavior: 'smooth' });
  }

  update() {
    const max = this.scroller.scrollWidth - this.scroller.clientWidth;
    if (max <= 0) {
      this.prevButton.hidden = true;
      this.nextButton.hidden = true;
      return;
    }
    this.prevButton.hidden = this.scroller.scrollLeft <= 0;
    this.nextButton.hidden = this.scroller.scrollLeft >= max - 1;
  }
}

if (!customElements.get('cart-recommendations-v2')) {
  customElements.define('cart-recommendations-v2', CartRecommendationsV2);
}
